import { Box, Text } from '@fozito/common-ui';
import { DollarAmountInputRef } from 'modules/POS/Cashier/components/DollarAmount/helpers';
import { InputWithKeyboardStyled } from 'modules/POS/Cashier/components/DollarAmount/Input';
import DollarAmountKeyboard from 'modules/POS/Cashier/components/DollarAmount/Keyboard';
import { styled } from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { IMultiCardResDataItem } from './index.interface';
import CashierVoidTicket from 'modules/POS/Cashier/features/Voided';
type Props = {
  onBack: () => void;
  onDone: () => void;
  onPay: () => void;
  onClear: () => void;
  remaining: number;
  total?: number;
  value?: number | null | undefined;
  onChange?: (val: number) => void;
  inputRefV2?: React.RefObject<DollarAmountInputRef>;
  cards: IMultiCardResDataItem[];
  billId?: string;
};
const PaymentKeyboard = ({
  onBack,
  inputRefV2,
  value,
  onClear,
  onChange,
  onDone,
  onPay,
  remaining,
  cards,
  billId,
}: Props) => {
  return (
    <PaymentKeyboardStyled className={'v2'}>
      <div className='keyboard'>
        <Box display='flex' flexDirection='column' gap='2'>
          <Text content_content_2_16_medium color_text_3 text_center style={{ fontSize: 20, marginTop: 16 }}>
            Enter Amount:
          </Text>
          <InputWithKeyboardStyled
            ref={inputRefV2}
            value={value}
            onChange={onChange}
            inputMode='none'
          />
          <Text content_content_2_16_medium color_text_3 text_center style={{ opacity: ((value || 0) > remaining) ? 1 : 0, fontSize: 16, transform: 'translateY(-15px)', color: 'rgb(245, 63, 63)' }}>
            Value cannot exceed {formatCurrency(remaining)}
          </Text>
          <DollarAmountKeyboard
            controlRef={inputRefV2}
            value={value}
            onChange={onChange}
          />
        </Box>
      </div>
      <ButtonsV2>
        {!cards.length ?
          <button disabled={!!cards.length} onClick={onBack} type="button" className="btn btn-close"><span>Close</span></button> :
          <CashierVoidTicket value={billId} useForMultiCards onDone={onBack} />
        }
        <button onClick={onClear} type="button" className="btn btn-clear"><span>Clear</span></button>
        <button disabled={(!value || (value || 0) > remaining)} onClick={remaining > 0 ? onPay : onDone} type="button" className="btn btn-done"><span>{remaining > 0 ? 'Pay' : 'Done'}</span></button>
      </ButtonsV2>
    </PaymentKeyboardStyled>
  );
};

export default PaymentKeyboard;

const PaymentKeyboardStyled = styled.div`
  flex-grow:1;
  display:flex;
  flex-direction: column;
  padding: 1rem 0;
  .keyboard {
    flex: 1;
    padding: 0 1.5rem;
  }

   &.v2 {
    background: #F5F5F5;
    padding: 0;
    .keyboard {
      flex: unset;
      padding: 0;
    }
  }
`;

const ButtonsV2 = styled.div`
display: flex;
align-self: stretch;
padding: 0 16px;
gap: 16px;
padding-bottom: 16px;
.btn {
  display: flex;
  height: 68px;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 4px;
  background: #E5E6EB;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
  span {
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  &.btn-clear {
    background: #C6E9EF;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
  }
  &.btn-done {
    background: #FF8890;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -4px 0px 0px #E7646D inset;
  }

  &:disabled {
    opacity: 0.7;
  }
}
`;